import DayPlugin from './DayPlugin';

export * from './Day';
export default DayPlugin;
